import { render, staticRenderFns } from "./dashboard-pinboard.vue?vue&type=template&id=fc34740a&"
import script from "./dashboard-pinboard.vue?vue&type=script&lang=ts&"
export * from "./dashboard-pinboard.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-pinboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports